// @ts-strict
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';
import { LMDrillAroundNode } from '@components/drillaround/lm-drill-around-wc';

@Component({
  selector: 'lm-drill-point-list',
  templateUrl: './lm-drill-point-list.component.html',
  styleUrls: [ './lm-drill-point-list.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
  })
export class LMDrillPointListComponent implements OnInit {

  @Input() info!: LMDrillAroundViewInfo;
  @Input() selectedNode!: LMDrillAroundNode;

  @Output() drillPointSelected = new EventEmitter<LMDrillAroundNode>();

  gridOptions!: SohoDataGridOptions;

  constructor(private ngZone: NgZone) {}

  ngOnInit() {
    this.gridOptions = this.buildGridOptions();
  }

  LMDrillAroundClickFunction = (e: Event, args: SohoDataGridColumnClickData[]) => {
    this.ngZone.run(() => {
      this.drillPointSelected.emit(args[0].item);
    });
  }

  private buildGridOptions(): SohoDataGridOptions {
    const gridColumns = this.buildGridColumns();

    // --------------------------------------------------
    // build grid data from the tree data node.
    // --------------------------------------------------
    let gridData: LMDrillAroundNode[] = [];
    if (this.selectedNode.children) {
      // ----------------------------------------------------------------------------------------------------
      // for some reason the datagrid will attempt to display all the selectedNode.childrens ancestors.
      // mapping the selectedNode.children to a new set of objects w/o each child's children.
      // ----------------------------------------------------------------------------------------------------
      gridData = this.selectedNode.children.map(node => {
        // ----------------------------------------------------------------------------------------------------
        // only mapping what is needed to display in the datagrid and for the
        // event handler in lm-drill-around.component:onViewDrillPointSelected
        // ----------------------------------------------------------------------------------------------------
        return {
          id: node.id,
          lmParent: (node as LMDrillAroundNode).lmParent,
          text: node.text
        };
      });
    }

    return {
      columns: gridColumns,
      dataset: gridData,
      selectable: 'single',
      paging: false,
      filterable: false,
      rowHeight: 'extra-small',
      isList: true,
      emptyMessage: null,
      enableTooltips: true,
      columnSizing: 'header',
      stretchColumn: 'last'
    } as SohoDataGridOptions;
  }

  private buildGridColumns(): SohoDataGridColumn[] {
    const drillArrowColumn: ListGridColumn = {
      id:        'drill-around',
      name:      Soho.Locale.translate('Select'),
      sortable:  false,
      resizable: false,
      formatter: Soho.Formatters.Button,
      icon:      'arrow-right',
      click:     this.LMDrillAroundClickFunction,
      align:     'center',
      // maxWidth:  40,
      // width:     40,
      // minWidth:  40,
    };

    const drillPointTitleColumn: ListGridColumn = {
      id: 'name',
      name: Soho.Locale.translate('DrillPoint'),
      field: 'text',
      formatter: Soho.Formatters.Text
    };

    return [
      drillArrowColumn,
      drillPointTitleColumn
    ];
  }
}
